// extracted by mini-css-extract-plugin
export default {"state":"index_state_GliwQ","statePic":"index_statePic_3T1FJ"};